import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const Block = ({ title, children, testid }) => (
  <section className="bg-white border border-slate-200 rounded-2xl p-4" data-testid={testid}><h3 className="font-bold text-slate-900 mb-2">{title}</h3>{children}</section>
);

export function SpaReviewTab() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/spa-units/review").then((r) => setD(r.data)).catch(() => setD({ products: [], units: [], other_entries: [] })); }, []);
  if (!d) return <div className="py-10 text-center text-slate-400"><Loader2 className="w-5 h-5 animate-spin inline" /></div>;
  return (
    <div className="space-y-3">
      <Block title={`Products to confirm (${d.products.length})`} testid="spa-review-products">
        <ul className="space-y-1.5 text-sm">{d.products.map((p) => (
          <li key={p.legacy_id}><b>{p.title}</b> <span className="text-slate-500">({p.category}, supplier: {p.supplier || "to confirm"}, rows {p.source_rows.join(", ")})</span>
            <div className="text-xs text-amber-700">{p.review_flags.join(" · ")}</div></li>))}</ul>
      </Block>
      <Block title={`Units with questions (${d.units.length})`} testid="spa-review-units">
        <ul className="space-y-1.5 text-sm">{d.units.map((u) => (
          <li key={u.unit_id}><b>Sheet row {u.source_row}: {u.title}</b>{u.serial && <span className="font-mono text-xs"> {u.serial}</span>} <span className="text-slate-500">- {u.status_label}{u.customer_note ? ` - ${u.customer_note}` : ""}</span>
            <div className="text-xs text-amber-700">{u.flags.join(" · ")}</div></li>))}</ul>
      </Block>
      <Block title={`Other spreadsheet entries, not imported as tubs (${d.other_entries.length})`} testid="spa-review-other">
        <div className="overflow-x-auto"><table className="w-full text-sm">
          <thead className="text-left text-[11px] uppercase text-slate-500"><tr><th className="py-1 pr-3">Sheet row</th><th className="py-1 pr-3">Type</th><th className="py-1 pr-3">Date in</th><th className="py-1 pr-3">Description</th><th className="py-1">Customer / note</th></tr></thead>
          <tbody>{d.other_entries.map((o) => (
            <tr key={o.source_row} className="border-t border-slate-100"><td className="py-1.5 pr-3">{o.source_row}</td><td className="py-1.5 pr-3 font-medium whitespace-nowrap">{o.kind}</td>
              <td className="py-1.5 pr-3 whitespace-nowrap">{o.date_in || "-"}</td><td className="py-1.5 pr-3">{o.model_raw || "-"}</td><td className="py-1.5">{o.customer_note || "-"}</td></tr>))}</tbody>
        </table></div>
      </Block>
    </div>
  );
}
